import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/code/lord',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-lord-home" */ '~/pages/r_code/lord/pages/home'
        )
    ),
  },
  {
    path: '/code/lord/my',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-lord-my" */ '~/pages/r_code/lord/pages/my'
        )
    ),
  },
] as RouteConfig[]
